import numbered from "numbered";
import { toTitleCase } from "../utilsByDomain/string/toTitleCase";

export const numberToWords = (
    num: number,
    options?: {
        removeHyphens?: boolean
    }
): string => {
        const asWords = numbered.stringify(num);
        if (options?.removeHyphens) {
            return asWords.replaceAll("-", " ");
        }
        return asWords;
    };

/** Shouldn't be used for curreny, because it doens't maintain two digits in the same way */
export const addSeperatorToNonCurrencyNumber = (num: number): string => Intl.NumberFormat("en-UK", { maximumFractionDigits: 20 }).format(num) // maximumFractionDigits: 20 is the max possible value

/** Just a helper alias for naming */
export const formatCurrencyWithoutSymbol = (num: number): string => formatCurrency(num, {removeSign: true});

/** By default includes the £ symbol */
export const formatCurrency = (
    num: number, 
    options?: {
        removeSign?: boolean
    }
): string => {
    const formatted = Intl.NumberFormat("en-UK", {
        style: "currency",
        currency: "GBP",
        currencyDisplay: options?.removeSign ? "code" : "symbol"
    }).format(num);
    if (options?.removeSign) {
        return formatted.replaceAll(/(GBP|\s)/g, "");
    }
    return formatted;
}

export const formatCurrencyFromPence = (pence: number): string => formatCurrency(pence/100);

export const formatCurrencyWithWordsFromPence = (pence: number): string => {
    const penceInteger = Math.round(pence);
    const poundsWithDecimal = penceInteger/100;
    const poundsOnly = poundsWithDecimal > 0 ? Math.floor(poundsWithDecimal) : Math.ceil(poundsWithDecimal);
    const penceRemainder = penceInteger % 100;

    return PRIVATE_formatCurrencyWithWords(poundsWithDecimal, poundsOnly, penceRemainder);
}

export const formatCurrencyWithWordsFromDecimalPounds = (decimal: number): string => {
    const poundsWithDecimal = decimal;
    const poundsOnly = Math.floor(poundsWithDecimal);
    const penceRemainder = Math.round(decimal * 100) % 100;

    return PRIVATE_formatCurrencyWithWords(poundsWithDecimal, poundsOnly, penceRemainder);
}

const PRIVATE_formatCurrencyWithWords = (poundsWithDecimal: number, poundsOnly: number, penceRemainder: number): string => {
    const words: string[] = [];
    const formatNumber = (num: number) => toTitleCase(numberToWords(num, {removeHyphens: true})).replaceAll("And", "and");

    words.push(`${formatNumber(poundsOnly)} Pounds`)

    if (penceRemainder !== 0) {
        words.push(`${formatNumber(penceRemainder)} Pence`)
    }

    return `${formatCurrency(poundsWithDecimal)} (${words.join(" and ")})`
}